const getMaxPuffsPerTime = (props = {}) => {
  const { puffsPerTime = 0, timesPerDay = 0 } = props;
  const maxPuffsPerTime = 8 - puffsPerTime * timesPerDay;

  return maxPuffsPerTime < 0 ? 0 : maxPuffsPerTime;
};

export default getMaxPuffsPerTime;
